import type { PageLoad } from './$types';
import dayjs from "dayjs";

export const load = (async ({ params }) => {

    let start = params.date ? dayjs(params.date) : dayjs().startOf('week');
    return {
        page_title: "Calendar",
        start,
        days: Array.from({ length: 7 }, (_, i) => start.add(i, 'day'))
    }
}) satisfies PageLoad;